// removed by extract-text-webpack-plugin
module.exports = {"th":"th-1PhUc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-header-column/table-header-column.less
 ** module id = 212
 ** module chunks = 0
 **/